import { handleActions } from 'redux-actions';
import u from 'updeep';
import * as actions from './csfActions';
 
const initialState = {
  landingStaticText: {},
  levelStaticText: {},
  isFetchingBooks: false,
  books: [],
  routineBooks: [],
  fetchingLevels: false,
  levels: {},
  fetchLevelFilters: false,
  filters: null,
  isFetchingInstructionalRoutines: false,
  instructionalRoutines: {},
  isFetchingProgrammeOverview: false,
  programmeOverview: {},
  isFetchingResource: false,
  resourceDetails: {},
  isLevelModalVisible: false,
  isDownloading: false,
  isFetchingProgramOverviewSection: false,
  programOverviewSection: {},
  isFetchingRoutineBooks: false,
  similarBooks: [],
  isFetchingSimilarBooks: false,
  isFetchingDownloadLevel: false
}

export default handleActions({
  [actions.receiveStaticLandingText]: (state, action) => u({
    landingStaticText: action.payload.data
  }, state),

  [actions.receiveStaticLessonText]: (state, action) => u({
    lessonStaticText: action.payload.data
  }, state),

  [actions.fetchCsfBooks]: (state, action) => u({
    isFetchingBooks: true
  }, state),

  [actions.receiveCsfBooks]: (state, action) => u({
      isFetchingBooks: false,
      books: action.payload.data.stories,
      levelStaticText : {
        title : action.payload.data.bannerTitle,
        description : action.payload.data.bannerDescription,
        image: action.payload.data.bannerImageLink,
        icon: action.payload.data.bannerIconLink,
        seeBooksText: action.payload.data.seeBooksText
      }
    }, state),

  [actions.fetchGetRoutineBooks]: (state, action) => u({
    isFetchingRoutineBooks: true
  }, state),

  [actions.recieveGetRoutineBooks]: (state, action) => u({
    isFetchingRoutineBooks: false,
    routineBooks: action.payload.routineBooks
  }, state),

  [actions.fetchGetLevels]: (state, action) => u({
    fetchingLevels: true
  }, state),

  [actions.receiveGetLevels]: (state, action) => u({
    fetchingLevels: false,
    levels: action.payload.data
  }, state),

  [actions.fetchGetLevelsFilters]: (state, action) => u({
    fetchLevelFilters: true
  }, state),

  [actions.recieveGetLevelsFilters]: (state, action) => u({
    fetchLevelFilters: false,
    filters: action.payload.filters
  }, state),

  [actions.fetchGetProgrammeOverview]: (state, action) => u({
    isFetchingProgrammeOverview: true
  }, state),

  [actions.receiveGetProgrammeOverview]: (state, action)=> u({
    isFetchingProgrammeOverview: false,
    programmeOverview: action.payload.data
  }, state),

  [actions.postDownload]: (state, action) => u({
    isFetchingDownloadLevel: true 
  }, state),

  [actions.recievePostDownload]: (state, action) => u({
    isFetchingDownloadLevel: false,
  }, state),

  [actions.removeLevelModal]: (state, action) => u({
    isLevelModalVisible: false
  }, state),

  [actions.fetchSimilarBooks]: (state, action) => u({
    isFetchingSimilarBooks: true
  }, state),

  [actions.recieveSimilarBooks]: (state, action) => u({
    isFetchingSimilarBooks: false,
    similarBooks : action.payload.similarBooks
  }, state),

  
  [actions.fetchInstructionalRoutines]: (state, action) => u({
    isFetchingInstructionalRoutines: true
  }, state),

  [actions.receiveInstructionalRoutines]: (state, action)=> u({
    isFetchingInstructionalRoutines: false,
    instructionalRoutines: action.payload.data.instructionalRoutines
  }, state),

  [actions.fetchCsfGetResourceDetail]: (state, action) => u({
    isFetchingResource: true
  }, state),

  [actions.recieveCsfGetResourceDetail]: (state, action) => u({
    isFetchingResource: false,
    resourceDetails: action.payload.data
  }, state), 

  [actions.addLevelModal]: (state, action) => u({
    isLevelModalVisible: true,
  }, state),

  [actions.removeLevelModal]: (state, action) => u({
    isLevelModalVisible: false
  }, state),

  [actions.fetchGetProgrammeOverviewCard]: (state, action) => u({
    isFetchingProgramOverviewSection: true
  }, state),

  [actions.receiveGetProgrammeOverviewCard]: (state, action) => u({
    isFetchingProgramOverviewSection: false,
    programOverviewSection: action.payload.data
  }, state),


  [actions.onTabChange]: (state, action)=> u({
    activeTabIndex: action.payload ? action.payload.activeTabIndex : 0
  }, state),

  }, initialState);



// WEBPACK FOOTER //
// ./src/redux/csfReducer.js